// @ts-ignore
import debounce from 'lodash/throttle';

export class TextmediaImage {
    caption: HTMLElement;

    constructor(image: HTMLElement) {
        if (this.caption = image.querySelector('[data-textmedia-image-caption]')) {
            this.addCaptionEvents(image);
        }
    }

    addCaptionEvents(image: HTMLElement) {
        const img = image.querySelector('img');
        this.resizeCaption(img.width);
        window.addEventListener('resize', debounce(() => {
            this.resizeCaption(img.width);
        }, 250));
        img.addEventListener('load', () => {
            this.resizeCaption(img.width);
        });
    }

    resizeCaption(width) {
        this.caption.style.maxWidth = width + 'px';
    }

}
document.addEventListener("DOMContentLoaded", function() {
    const images: NodeListOf<HTMLElement> = document.querySelectorAll('[data-textmedia-image]');
    images.forEach((image) => {
        new TextmediaImage(image);
    });
});
